import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpSectionConcept のスタイル
 */
export const hotlineLpSectionConceptStyle = tv({
    slots: {
        base: ['relative'],
        bgImageBox: [
            'absolute',
            'w-[180px] -top-[14px] left-1/2 translate-x-[56px]',
            'sm:w-[201px] sm:top-[6px] sm:translate-x-[242px]',
            'md:w-[358px] md:-top-[48px] md:translate-x-[101px]',
            'lg:translate-x-[84px]',
            'xl:-top-[90px] xl:-translate-x-[46px]',
            'min-[1440px]:translate-x-[65px]',
        ],
        contentBox: [
            'mx-auto',
            'max-md:mt-[10px]',
            'md:w-full md:flex md:flex-col md:items-end',
            'md:pr-[50px] md:max-w-[1180px]',
            'lg:pr-[56px]',
            'xl:pr-[10px] md:max-w-[1280px]',
            'min-[1440px]:max-w-[1320px]',
        ],
        description: [
            'relative z-10 mt-12 sm:mt-24 max-md:mx-32',
            'text-center md:text-left',
        ],
        heading: ['relative z-10'],
        imageWrapper: [
            'relative md:absolute',
            'w-[110%] left-1/2 translate-x-[calc(-50%-61px)]',
            'sm:w-[74.5vw] sm:translate-x-[calc(-50%-84px)]',
            'md:w-[56vw] md:right-[57.5%] md:-top-[54px] md:left-auto md:translate-x-0',
            'lg:w-[52.6vw] lg:right-[55.5%] lg:-top-[94px]',
            'xl:w-[57.8vw] xl:right-[53.5%] xl:-top-[220px]',
            'min-[1440px]:w-[min(50vw,968px)] min-[1440px]:right-[52.2%] min-[1440px]:-top-[288px]', // 1440~
        ],
        text: [
            'text-[14px] sm:text-[16px] xl:text-[18px] text-[#231916]',
            'leading-[25.2px] sm:leading-[32px] xl:leading-[36px]',
        ],
        textWrapper: [
            'relative',
            'max-md:translate-y-[-4px]',
            'md:max-w-[490px]',
            'md:w-[50%]',
            'lg:max-w-[551px]',
            'xl:w-auto lg:max-w-[612px]',
            'min-[1440px]:max-w-[642px]',
        ],
    },
});
